export enum IDs {
  HEADER_OPEN_BURGER_MENU = 'header_open_burger_menu',
  HEADER_LINK_MENU = 'header_link_menu',
  HEADER_SIDEBAR_MENU = 'header_sideBar_menu',
  HEADER_OPEN_WALLET_MODAL_BUTTON = 'header_open_walletModal_button',
  HEADER_CONNECT_WALLET_BUTTON = 'header_connectWallet_button',
  AUTH_MODAL_CONNECT_WALLET_MODAL = 'authModal_connectWallet_modal',
  ACCOUNT_MODAL_LOGOUT_MODAL = 'accountModal_logout_modal',
  AUTH_MODAL_CONNECT_METAMASK_BUTTON = 'authModal_connectMetaMask_button',
  ACCOUNT_MODAL_LOGOUT_BUTTON = 'accountModal_logout_button',
  AUTH_MODAL_CONNECT_WALLET_CONNECT_BUTTON = 'authModal_connectWalletConnect_button',
  FILTER_HANDLE_CHANGE_CHAIN_BUTTON = 'filter_handle_change_chain_button',
  ITEM_ETF_CARD_BLOCK = 'filter_handle_change_chain_button',
  ETF_CARD_OPEN_FUND_BUTTON = 'etfCard_openFund_button',
  ETF_CARD_LIST = 'etfCard_list',
  ACTION_CARD_ETF_BLOCK = 'actionCardEtf_block',
  ACTION_CARD_ETF_SINGLE_MINT_SELECT = 'actionCardEtf_singleMint_select',
  ACTION_CARD_ETF_SINGLE_BURN_SELECT = 'actionCardEtf_singleBurn_select',
  ACTION_CARD_ETF_SINGLE_MINT_SIMULATE_VALUE = 'actionCardEtf_singleMint_simulateValue',
  ACTION_CARD_ETF_SINGLE_BURN_SIMULATE_VALUE = 'actionCardEtf_singleBurn_simulateValue',
}
